// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__WW3ro","overflowing":"ReadFullNote_overflowing__Ptu12"};